/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   poi Bizo
 */

import type { Poi as PoiType, RawPoi } from '@zcode/state-type'
import { Bizo, autoclass } from '../../shared/bizos/base'

const DEFINITION = {
  address: 'address',
  city: 'city',
  createdOn: 'created_on',
  lat: 'lat',
  lng: 'lng',
  modifiedOn: 'modified_on',
  name: 'name',
  poiId: 'poi_id',
  poiType: 'poi_type',
  state: 'state',
  zipcode: 'zipcode',
} as const

export default autoclass<PoiType, RawPoi>(
  'POI',
  class POI extends Bizo<PoiType, RawPoi> {},
  DEFINITION,
  null
)
